import React from 'react';

interface LomavisTitle1Props {
    text: string;
}

export const LomavisTitle1: React.FC<LomavisTitle1Props> = ({ text }) => {
    return (
        <div className="d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
            {text}
        </div>
    );
};
